import "amazon-connect-streams";
import "amazon-connect-chatjs";
export const setup = (AWS_CONNECT_REGION: string) => {
	connect.ChatSession.setGlobalConfig({
		loggerConfig: {
			// optional, the logging configuration. If omitted, no logging occurs
			logger: {
				// optional, a logger object implementation
				debug: (msg) => {}, // REQUIRED, can be any function
				info: (msg) => {}, // REQUIRED, can be any function
				warn: (msg) => {}, // REQUIRED, can be any function
				error: (msg) => {} // REQUIRED, can be any function
			},
			level: connect.ChatSession.LogLevel.WARN // optional, defaults to: `connect.ChatSession.LogLevel.INFO`
		},
		region: AWS_CONNECT_REGION
	});
};
